import { withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-765e3b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-search" }
const _hoisted_2 = { class: "home-search-form" }
const _hoisted_3 = ["placeholder", "aria-label"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PresavedSearches = _resolveComponent("PresavedSearches")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("input", {
        type: "search",
        onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.navigateToSearch && _ctx.navigateToSearch(...args)), ["prevent"]), ["enter"])),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToSearchWithQuery($event.target.value))),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToSearch && _ctx.navigateToSearch(...args))),
        placeholder: _ctx.$t('landing-page.search-all-works'),
        "aria-label": _ctx.$t('landing-page.search-all-works')
      }, null, 40, _hoisted_3),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navigateToSearch && _ctx.navigateToSearch(...args))),
        type: "button",
        "aria-label": _ctx.$t('general.search')
      }, _hoisted_6, 8, _hoisted_4)
    ]),
    _createVNode(_component_PresavedSearches, { light: true })
  ]))
}